import { Component, type ErrorInfo, type ReactNode } from "react";

/** Isolates a single widget so one throwing widget can't take down the dock. */
export class DockErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("Dock widget crashed", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="px-3 py-2 text-xs text-[#8b93c7]">This widget hit a snag.</div>
        )
      );
    }
    return this.props.children;
  }
}
